import React, { useCallback } from 'react';

export interface RowsPerPageSelectProps {
  disabled?: boolean;
  options: number[];
  testId?: string;
  value: number;
  onChange: (value: number) => void;
}

const SELECT_CLASSES = `
  h-10 px-3 pr-8
  text-sm font-medium
  border border-gray-300 rounded-md
  bg-white text-primary-700
  transition-colors duration-150
  hover:bg-primary-50 hover:border-primary-300
  focus:outline-none focus:ring-2 focus:ring-blue-100
  disabled:pointer-events-none disabled:bg-gray-100 disabled:text-gray-400 disabled:border-gray-200
  appearance-none cursor-pointer
  bg-[url('data:image/svg+xml;charset=UTF-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2212%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20stroke%3D%22%234A5568%22%20stroke-width%3D%222%22%3E%3Cpath%20d%3D%22M6%209l6%206%206-6%22%2F%3E%3C%2Fsvg%3E')]
  bg-no-repeat bg-[right_0.5rem_center]
`.trim();

export const RowsPerPageSelect: React.FC<RowsPerPageSelectProps> = React.memo(({
  value,
  options,
  onChange,
  disabled = false,
  testId = 'rows-per-page-select',
}) => {
  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLSelectElement>) => {
      onChange(Number(e.target.value));
    },
    [onChange]
  );

  return (
    <div className="flex items-center gap-2" data-testid={testId}>
      <span className="text-sm font-normal text-primary-700 whitespace-nowrap">
        Rows per page:
      </span>
      <select
        value={value}
        onChange={handleChange}
        disabled={disabled}
        className={SELECT_CLASSES}
        data-testid={`${testId}-dropdown`}
        aria-label="Rows per page"
      >
        {options.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
    </div>
  );
});

RowsPerPageSelect.displayName = 'RowsPerPageSelect';
